import React from 'react';
import { CheckCircle2, TrendingUp } from 'lucide-react';
import { GlassCard, SectionShell } from './LandingPrimitives';

const paymentFeatures = [
  'Advance tracking',
  'Daily reconciliation',
  'Revenue analytics',
  'Payment reminders',
];

const PaymentsSection = () => {
  return (
    <SectionShell
      id="payments"
      eyebrow="Payments & Revenue"
      title="Stop revenue leakage before it starts"
      description="Automate follow-ups and reconcile collections daily with a clear source of truth for your business."
    >
      <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr]">
        <GlassCard>
          <ul className="space-y-3">
            {paymentFeatures.map((feature) => (
              <li key={feature} className="flex items-center gap-3 text-sm text-ga-text-muted">
                <CheckCircle2 className="h-4 w-4 text-ga-primary" />
                {feature}
              </li>
            ))}
          </ul>
        </GlassCard>

        <GlassCard className="border border-ga-green/40">
          <div className="flex items-center gap-2 text-ga-primary">
            <TrendingUp className="h-4 w-4" />
            <p className="text-xs uppercase tracking-[0.18em]">Stats highlight</p>
          </div>
          <p className="mt-4 text-3xl font-bold text-ga-text-primary">+18%</p>
          <p className="text-sm text-ga-text-muted">Projected monthly revenue lift with structured booking + payment flow.</p>
          <div className="mt-5 grid grid-cols-2 gap-3 text-sm">
            <div className="rounded-xl bg-ga-bg-surface-subtle p-3">
              <p className="text-ga-text-subtle">Missed Advances</p>
              <p className="font-semibold text-ga-text-primary">-42%</p>
            </div>
            <div className="rounded-xl bg-ga-bg-surface-subtle p-3">
              <p className="text-ga-text-subtle">Follow-up Time</p>
              <p className="font-semibold text-ga-text-primary">-31%</p>
            </div>
          </div>
        </GlassCard>
      </div>
    </SectionShell>
  );
};

export default PaymentsSection;
